import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { ImagesService, Resolution } from '@libraries/assets';
import { isMobile } from '@libraries/ui-state';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'generic-page',
  templateUrl: './generic-page.component.html',
  styleUrls: ['./generic-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GenericPageComponent implements OnChanges {
  @Input() image: string;
  @Input() hidePortalMenu = false;
  @Input() showAppHeader = true;
  @Input() showImage = true;
  @Input() showTucieloLogo = false;

  @HostBinding('class.column-layout')
  @Input()
  columnLayout = true;
  imageChanges = new BehaviorSubject('');

  resolution: Resolution;
  resolutionChanges = this.store.select(isMobile).pipe(tap(this.updateResolution.bind(this)));

  get isMobile() {
    return this.resolution === Resolution.mobile;
  }

  constructor(private store: Store, public images: ImagesService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.image && changes.image.previousValue !== changes.image.currentValue) {
      this.imageChanges.next(changes.image.currentValue);
    }
  }

  updateResolution(mobile: boolean) {
    this.resolution = mobile ? Resolution.mobile : Resolution.desktop;
  }
}
